import { dwsCompletedComponent } from './completed.component';

export const dwsCompletedStateName = 'app.ticket.dwsReceivingCompleted';

export const dwsCompletedState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: dwsCompletedStateName,
    url: '/dwsCompleted',
    component: dwsCompletedComponent.name,
    data: { requiresAuth: true },
  });
};
